import { useSWR } from '@tiger/swr';
import type { IdTypeItem } from 'components/forms/IdType';
import { IdTypeInfoCategoryEnum } from 'types/common';
import { IdTypeEnum, LicenseEnum } from 'types/customer';
import API from 'utils/API';

/** 获取某类证件的具体配置信息 */
export function useGetIdTypeInfo({ idType, issueCountry }: { idType?: IdTypeEnum; issueCountry?: string }) {
    return useSWR<IdTypeItem>(
        idType && issueCountry
            ? {
                  url: API.INFOBASE.getIdTypeInfo(),
                  params: {
                      id_type: idType,
                      issue_country: issueCountry
                  }
              }
            : null,
        {
            immutable: true,
            dataChain: res => res.data
        }
    );
}

/** 获取证件类型列表 */
export function useGetIdTypeList(category: IdTypeInfoCategoryEnum, issueCountry?: string) {
    return useSWR<IdTypeItem[]>(
        issueCountry
            ? {
                  url: API.INFOBASE.getIdTypeList(),
                  params: {
                      issue_country: issueCountry,
                      license: LicenseEnum.MARSCO,
                      // 如果后续新增第二证件类型，category要相应调整
                      category
                  }
              }
            : null,
        {
            immutable: true,
            dataChain: res => res.data
        }
    );
}
